import React from 'react'
import Suspense from 'components/Suspense'
import { useTheme } from '@mui/material/styles'

export interface ISkillSuggestionsButton {
  onClick: () => void
}

const SkillSuggestionsButton = ({ onClick }: ISkillSuggestionsButton) => {
  const theme = useTheme()

  return (
    <Suspense>
      <span
        role="button"
        style={{ color: theme.palette.primary.main, cursor: 'pointer' }}
        onClick={onClick}
      >
        add it
      </span>
    </Suspense>
  )
}

export default SkillSuggestionsButton
